export default __webpack_public_path__ + "images/bright_contrast.2b8430d.svg";